import { useEffect, useState } from 'react'
import { api } from '../api'

// <img>/<video> não enviam o header Authorization. Este componente busca uma
// URL assinada (curta) para o conteúdo e a usa — mantendo a mídia protegida.
export function MediaImage({ sha, alt, style, className }: {
  sha: string
  alt?: string
  style?: React.CSSProperties
  className?: string
}) {
  const [src, setSrc] = useState('')
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let alive = true
    if (!sha) {
      setSrc('')
      return
    }
    api.media.signedUrl(sha)
      .then((url) => { if (alive) setSrc(url) })
      .catch(() => { if (alive) setFailed(true) })
    return () => { alive = false }
  }, [sha])

  if (failed) {
    return (
      <div className={className} style={{ ...style, background: 'var(--surface-3)', display: 'flex', alignItems: 'center', justifyContent: 'center', font: '400 9.5px/1.4 var(--font-mono)', color: 'var(--text-3)', textAlign: 'center', padding: 6 }}>
        imagem indisponível
      </div>
    )
  }
  if (!src) {
    return <div className={className} style={{ ...style, background: 'var(--surface-3)' }} />
  }
  return <img src={src} alt={alt} className={className} style={style} />
}
